var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('a-avatar',{staticClass:"avatar mrg-right-12",attrs:{"src":_vm.src,"size":_vm.sizeResponsive}}):_c('a-avatar',{staticClass:"avatar mrg-right-12",attrs:{"size":_vm.sizeResponsive,"icon":"user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }